// removed by extract-text-webpack-plugin
module.exports = {"ClockContainer":"clock__ClockContainer__L5_XE","StartTime":"clock__StartTime__1JlcU","EndTime":"clock__EndTime__3NRnr","AbsClocks":"clock__AbsClocks__2n9Zm","RelTime":"clock__RelTime__2MgfL","AbsTime":"clock__AbsTime__3usTo"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Replayer/clock.css
// module id = 1707
// module chunks = 2